import {
    CONTAINER_CONTRACT_NUMBER_VALIDATED,
    CONTAINER_CUSTOMER_NUMBER_VALIDATED,
    CONTAINER_EMAIL_VALIDATED,
    CONTAINER_FULL_ADDRESS_VALIDATED,
    CONTAINER_FULL_NAME_VALIDATED,
    CONTAINER_NOTE_VALIDATED,
    CONTAINER_RESULT_PAGE,
    CONTAINER_TERMINATION_DATE_VALIDATED,
    CONTAINER_TIMESTAMP,
} from '../constant';
import { ICustomerInformation } from '../interface';
import { convertTimestamp } from './convertTimestamp.helper';

/**
 * use the customerInformation state (validated data from the DXL service)
 * and fill the result page with its properties
 */
export const fillResultTable = (customerInformation: ICustomerInformation) => {
    // workaround for logo for now
    // TODO: Remove later
    const resultPage = document.getElementById(CONTAINER_RESULT_PAGE);
    const logoDiv = document.createElement('div');
    logoDiv.setAttribute('id', 'logo-for-print');
    resultPage?.prepend(logoDiv);

    const {
        firstName,
        lastName,
        street,
        buildingNumber,
        postcode,
        city,
        emailAddress,
        customerNumber,
        contractNumber,
        desiredTerminationDate,
        note,
        timestamp,
    } = customerInformation;

    const date = timestamp && convertTimestamp(timestamp);
    const address = formatAddress(street, buildingNumber, postcode, city);

    updateElement(CONTAINER_FULL_NAME_VALIDATED, `${firstName} ${lastName}`);
    updateElement(CONTAINER_CUSTOMER_NUMBER_VALIDATED, customerNumber);
    updateElement(CONTAINER_FULL_ADDRESS_VALIDATED, address);
    updateElement(CONTAINER_CONTRACT_NUMBER_VALIDATED, contractNumber);
    updateElement(CONTAINER_EMAIL_VALIDATED, emailAddress);
    updateElement(CONTAINER_TERMINATION_DATE_VALIDATED, desiredTerminationDate);
    updateElement(CONTAINER_NOTE_VALIDATED, note);

    // special case the HTML has a different format
    const timestampElement = document.getElementById(CONTAINER_TIMESTAMP);

    if (timestampElement && date) {
        timestampElement.innerHTML = date;
    }
};

/**
 * format address to return the needed string value properly
 */
export const formatAddress = (street: string, buildingNumber: string, postcode: string, city: string): string => {
    let formattedAddress = `${street} ${buildingNumber}`;

    if (postcode || city) {
        formattedAddress += ',';
    }

    if (postcode) {
        formattedAddress += ` ${postcode}`;
    }

    if (city) {
        formattedAddress += ` ${city}`;
    }

    return formattedAddress.trim();
};

/**
 * insert value into headline in case element and value is present
 */
const updateElement = (elementId: string, value?: string) => {
    const element = document.getElementById(elementId);

    if (element && value) {
        element.innerHTML = `<h4 class="ws10-headline">${value}</h4>`;
    }
};
